import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Delivery } from "../../../../services/Delivery";

export const useDeliveryDiasIndisponiveis = (
  uuidDelivery: string,
  concessionaria?: boolean,
) => {
  const query = useQuery({
    queryKey: ["delivery-dias-indisponiveis", uuidDelivery, concessionaria],
    queryFn: () =>
      Delivery.getDiasIndisponiveis({ uuidDelivery, concessionaria }),
    select: (response) => response.data,
    enabled: !!uuidDelivery,
  });

  useEffect(() => {
    if (!query.isError) return;

    const {
      response: {
        data: { mensagem },
      },
    } = query.error as any;

    toast.error(mensagem);
  }, [query.isError]);

  return query;
};
